import { createTheme } from "@mui/material/styles";

export function createAppTheme(mode = "dark") {
  const isDark = mode === "dark";
  return createTheme({
    palette: {
      mode,
      primary: { main: "#79b8c9", light: "#a0cdd9", dark: "#5a8a97" },
      secondary: { main: "#d76d87", light: "#e392a6", dark: "#b04d68" },
      error: { main: "#c77e7e", light: "#d9a0a0", dark: "#a05858" },
      warning: { main: "#d4a574", light: "#e3c29c", dark: "#b8864f" },
      info: { main: "#7ea8c7", light: "#a0c1db", dark: "#5c7fa1" },
      success: { main: "#83b894", light: "#a4ccb3", dark: "#619673" },
      background: isDark
        ? { default: "#0b1220", paper: "rgba(249, 214, 255, 0.03)" }
        : { default: "#f0f4f8", paper: "#ffffff" },
      text: isDark
        ? { primary: "rgba(255,255,255,0.87)", secondary: "rgba(255,255,255,0.60)" }
        : { primary: "rgba(0,0,0,0.87)", secondary: "rgba(0,0,0,0.60)" },
      divider: isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)",
    },
    typography: {
      fontFamily: '"Roboto Condensed", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeightLight: 300,
      fontWeightRegular: 300,
      fontWeightMedium: 400,
      fontWeightBold: 500,
      h1: { fontWeight: 300 }, h2: { fontWeight: 300 }, h3: { fontWeight: 300 },
      h4: { fontWeight: 300 }, h5: { fontWeight: 300 }, h6: { fontWeight: 400 },
      subtitle1: { fontWeight: 300 }, subtitle2: { fontWeight: 400 },
      body1: { fontWeight: 300 }, body2: { fontWeight: 300 },
      button: { fontWeight: 400 }, caption: { fontWeight: 300 }, overline: { fontWeight: 300 },
    },
    shape: { borderRadius: 10 },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backdropFilter: isDark ? "blur(12px)" : "none",
            border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.08)",
          },
        },
        defaultProps: { elevation: 0 },
      },
    },
  });
}

export default createAppTheme("dark");
